const initialState = {
    healthPlan: JSON.parse(localStorage.getItem('healthPlan')) || null,
};

const healthPlanReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_HEALTH_PLAN':
            localStorage.setItem('healthPlan', JSON.stringify(action.payload));
            return {
                ...state,
                healthPlan: action.payload,
            };
        default:
            return state;
    }
};

export default healthPlanReducer;